import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, vShow as _vShow, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/i-money1.jpg'
import _imports_1 from '../../../assets/images/arrowtopleft.svg'
import _imports_2 from '../../../assets/images/arrowtopright.svg'
import _imports_3 from '../../../assets/images/check.svg'
import _imports_4 from '../../../assets/images/imoji.svg'
import _imports_5 from '../../../assets/images/arrowbottomleft.svg'
import _imports_6 from '../../../assets/images/arrowbottomright.svg'


const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing",
  id: "back"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = {
  key: 1,
  type: "button",
  class: "default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
  "data-bs-toggle": "modal",
  "data-bs-target": "#generateLink"
}
const _hoisted_6 = { class: "d-sm-flex align-items-center" }
const _hoisted_7 = { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" }
const _hoisted_8 = {
  key: 1,
  type: "button",
  class: "d-block text-center w-100 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25",
  "data-bs-toggle": "modal",
  "data-bs-target": "#sendMoneyModal",
  style: {"background-color":"#EB9355"}
}
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "form-check mb-0" }
const _hoisted_24 = { class: "badge text-outline-primary" }
const _hoisted_25 = {
  key: 0,
  class: "flaticon-web",
  style: {"font-weight":"bold"}
}
const _hoisted_26 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = {
  key: 6,
  class: "badge text-outline-success"
}
const _hoisted_42 = {
  key: 7,
  class: "badge text-outline-danger"
}
const _hoisted_43 = {
  key: 8,
  class: "badge text-outline-info"
}
const _hoisted_44 = {
  key: 9,
  class: "badge text-outline-info"
}
const _hoisted_45 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { id: "transactionsTable" }
const _hoisted_48 = {
  id: "headerLeftText",
  class: "d-lg-inline-block p-2 text-start"
}
const _hoisted_49 = {
  id: "headerRightText",
  class: "d-inline-block p-2 text-end"
}
const _hoisted_50 = {
  id: "headerLeftText",
  class: "d-lg-inline-block p-2 text-start",
  style: {"margin-top":"-2%"}
}
const _hoisted_51 = { style: {"margin-top":"7%"} }
const _hoisted_52 = {
  class: "text-center shadow-none lh-1 fw-medium",
  id: "title",
  style: {}
}
const _hoisted_53 = {
  class: "text-center",
  id: "subtitle"
}
const _hoisted_54 = {
  style: {"padding-left":"1%","padding-right":"1%"},
  class: ""
}
const _hoisted_55 = {
  id: "tableLayout",
  class: "table",
  style: {"margin-right":"1%"}
}
const _hoisted_56 = { class: "text-uppercase fw-medium shadow-none tableHeader" }
const _hoisted_57 = { class: "text-uppercase fw-medium shadow-none" }
const _hoisted_58 = { class: "text-uppercase fw-medium shadow-none" }
const _hoisted_59 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none"
}
const _hoisted_60 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none"
}
const _hoisted_61 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none"
}
const _hoisted_62 = { class: "fw-medium" }
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_65 = { class: "fw-medium" }
const _hoisted_66 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_67 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_68 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_69 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_70 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_71 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_72 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_73 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_74 = { class: "fw-bold" }
const _hoisted_75 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_76 = { class: "fw-bold" }
const _hoisted_77 = { class: "fw-bold" }
const _hoisted_78 = {
  key: 2,
  class: "mt-15 mt-md-0"
}
const _hoisted_79 = { class: "pagination mb-0" }
const _hoisted_80 = {
  key: 0,
  class: "page-item"
}
const _hoisted_81 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 1,
  class: "page-item"
}
const _hoisted_84 = {
  key: 3,
  class: "mt-15 mt-md-0"
}
const _hoisted_85 = { class: "pagination mb-0" }
const _hoisted_86 = {
  key: 0,
  class: "page-item"
}
const _hoisted_87 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_88 = ["onClick"]
const _hoisted_89 = {
  key: 1,
  class: "page-item"
}
const _hoisted_90 = {
  key: 4,
  class: "mt-15 mt-md-0"
}
const _hoisted_91 = { class: "pagination mb-0" }
const _hoisted_92 = {
  key: 0,
  class: "page-item"
}
const _hoisted_93 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = {
  key: 1,
  class: "page-item"
}
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { key: 2 }
const _hoisted_99 = {
  class: "modal fade",
  id: "sendMoneyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = { class: "modal-header" }
const _hoisted_103 = { class: "modal-title fs-5" }
const _hoisted_104 = { class: "modal-body" }
const _hoisted_105 = { style: {"margin-bottom":"5%"} }
const _hoisted_106 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_107 = {
  class: "text-black fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_108 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_109 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_110 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_111 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = { class: "col-md-4" }
const _hoisted_114 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_115 = { class: "invalid-feedback" }
const _hoisted_116 = { class: "col-md-4" }
const _hoisted_117 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_118 = { value: "" }
const _hoisted_119 = ["value"]
const _hoisted_120 = { class: "col-md-4" }
const _hoisted_121 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_122 = { class: "invalid-feedback" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-4" }
const _hoisted_125 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_126 = { class: "invalid-feedback" }
const _hoisted_127 = { class: "col-md-4" }
const _hoisted_128 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_129 = { value: "" }
const _hoisted_130 = ["value"]
const _hoisted_131 = {
  class: "col-md-4",
  id: "container_sub_business"
}
const _hoisted_132 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_133 = { value: "" }
const _hoisted_134 = ["value"]
const _hoisted_135 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_136 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_137 = { value: "" }
const _hoisted_138 = ["value"]
const _hoisted_139 = {
  class: "row",
  style: {"margin-top":"1%"}
}
const _hoisted_140 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_141 = { class: "invalid-feedback" }
const _hoisted_142 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_143 = { class: "modal-footer" }
const _hoisted_144 = ["disabled"]
const _hoisted_145 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_146 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_147 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_148 = { class: "modal-content" }
const _hoisted_149 = { class: "modal-header" }
const _hoisted_150 = {
  key: 0,
  class: "modal-title fs-5"
}
const _hoisted_151 = {
  key: 1,
  class: "modal-title fs-5"
}
const _hoisted_152 = { class: "modal-tabs" }
const _hoisted_153 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_154 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_155 = {
  class: "modal-body",
  style: {"max-height":"70vh","overflow-y":"auto"}
}
const _hoisted_156 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_157 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_158 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_159 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_160 = { class: "row g-3" }
const _hoisted_161 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_162 = { value: "" }
const _hoisted_163 = ["value"]
const _hoisted_164 = { class: "col-md-6" }
const _hoisted_165 = { value: "" }
const _hoisted_166 = ["value"]
const _hoisted_167 = { class: "row g-3 mt-1" }
const _hoisted_168 = { class: "col-md-6" }
const _hoisted_169 = { value: "" }
const _hoisted_170 = { class: "col-md-6" }
const _hoisted_171 = { value: "" }
const _hoisted_172 = { class: "row g-3 mt-1" }
const _hoisted_173 = { class: "col-md-6" }
const _hoisted_174 = { class: "col-md-6" }
const _hoisted_175 = { class: "row g-3 mt-1" }
const _hoisted_176 = { class: "col-md-6" }
const _hoisted_177 = { class: "col-md-6" }
const _hoisted_178 = { key: 0 }
const _hoisted_179 = { class: "row g-3" }
const _hoisted_180 = { class: "col-md-6" }
const _hoisted_181 = { class: "col-md-6" }
const _hoisted_182 = { class: "row g-3 mt-1" }
const _hoisted_183 = { class: "col-md-4" }
const _hoisted_184 = { class: "col-md-4" }
const _hoisted_185 = { value: "" }
const _hoisted_186 = { class: "col-md-4" }
const _hoisted_187 = { value: "" }
const _hoisted_188 = { class: "row g-3 mt-1" }
const _hoisted_189 = { class: "col-md-6" }
const _hoisted_190 = { class: "col-md-6" }
const _hoisted_191 = {
  key: 1,
  class: "row",
  style: {"margin-top":"2%"}
}
const _hoisted_192 = { class: "col-12" }
const _hoisted_193 = {
  class: "alert alert-warning mb-0",
  role: "alert"
}
const _hoisted_194 = { class: "modal-footer" }
const _hoisted_195 = ["disabled"]
const _hoisted_196 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_197 = { style: {"color":"#FFF"} }
const _hoisted_198 = ["disabled"]
const _hoisted_199 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_200 = { style: {"color":"#FFF"} }
const _hoisted_201 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_202 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_203 = { class: "modal-content" }
const _hoisted_204 = { class: "modal-header" }
const _hoisted_205 = { class: "modal-title fs-5" }
const _hoisted_206 = { class: "modal-tabs" }
const _hoisted_207 = { class: "modal-body" }
const _hoisted_208 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_209 = { class: "row g-3" }
const _hoisted_210 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_211 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_212 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_213 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_214 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_215 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_216 = {
  key: 3,
  class: "col-12 col-md-4"
}
const _hoisted_217 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_218 = {
  key: 4,
  class: "col-12 col-md-4"
}
const _hoisted_219 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_220 = {
  key: 5,
  class: "col-12 col-md-4"
}
const _hoisted_221 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_222 = { key: 0 }
const _hoisted_223 = { class: "row g-3" }
const _hoisted_224 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_225 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_226 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_227 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_228 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_229 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_230 = ["value"]
const _hoisted_231 = {
  key: 3,
  class: "col-12 col-md-4"
}
const _hoisted_232 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_233 = ["value"]
const _hoisted_234 = { class: "row g-3 mt-1" }
const _hoisted_235 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_236 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_237 = ["value"]
const _hoisted_238 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_239 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_240 = ["value"]
const _hoisted_241 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_242 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_243 = { class: "row g-3 mt-1" }
const _hoisted_244 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_245 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_246 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_247 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_248 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_249 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_250 = ["value"]
const _hoisted_251 = { class: "row g-3 mt-1" }
const _hoisted_252 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_253 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_254 = ["value"]
const _hoisted_255 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_256 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_257 = ["value"]
const _hoisted_258 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_259 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_260 = ["value"]
const _hoisted_261 = { class: "row g-3 mt-1" }
const _hoisted_262 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_263 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_264 = ["value"]
const _hoisted_265 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_266 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_267 = { class: "row g-3 mt-1" }
const _hoisted_268 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_269 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_270 = ["value"]
const _hoisted_271 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_272 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_273 = ["value"]
const _hoisted_274 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_275 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_276 = {
  key: 3,
  class: "col-12 col-md-4"
}
const _hoisted_277 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_278 = ["value"]
const _hoisted_279 = { class: "row g-3 mt-1" }
const _hoisted_280 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_281 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_282 = ["value"]
const _hoisted_283 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_284 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_285 = {
  key: 0,
  class: "row g-3 mt-1"
}
const _hoisted_286 = { class: "col-12" }
const _hoisted_287 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_288 = ["value"]
const _hoisted_289 = {
  class: "modal fade",
  id: "generateLink",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_290 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_291 = { class: "modal-content" }
const _hoisted_292 = { class: "modal-header" }
const _hoisted_293 = { class: "modal-title fs-5" }
const _hoisted_294 = { class: "modal-body" }
const _hoisted_295 = { style: {"margin-bottom":"5%"} }
const _hoisted_296 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_297 = {
  class: "text-black fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_298 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_299 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_300 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_301 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_302 = { class: "row" }
const _hoisted_303 = { class: "col-md-3" }
const _hoisted_304 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_305 = { value: "SIMPLE" }
const _hoisted_306 = { value: "DOUBLE" }
const _hoisted_307 = { class: "col-md-3" }
const _hoisted_308 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_309 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_310 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_311 = {
  key: 1,
  class: "col-md-1",
  style: {"padding-top":"2%"}
}
const _hoisted_312 = {
  class: "d-block text-black fw-semibold mb-10",
  style: {"visibility":"hidden"}
}
const _hoisted_313 = { class: "modal-footer" }
const _hoisted_314 = ["disabled"]
const _hoisted_315 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_316 = {
  class: "modal fade",
  id: "changeStatusModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_317 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_318 = { class: "modal-content edit-status-modal-content" }
const _hoisted_319 = { class: "modal-body pt-10" }
const _hoisted_320 = { class: "edit-status-code-box mb-20" }
const _hoisted_321 = { class: "edit-status-code-value" }
const _hoisted_322 = { class: "form-group mb-15" }
const _hoisted_323 = { class: "form-group mb-15" }
const _hoisted_324 = { class: "form-group mb-15" }
const _hoisted_325 = { class: "form-group mb-5" }
const _hoisted_326 = {
  key: 0,
  class: "text-danger fs-13"
}
const _hoisted_327 = {
  key: 0,
  class: "text-danger fs-13 mt-10 mb-0"
}
const _hoisted_328 = { class: "modal-footer border-0 pt-0" }
const _hoisted_329 = ["disabled"]
const _hoisted_330 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_331 = {
  class: "modal fade",
  id: "transactionStatusModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_332 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_333 = { class: "modal-content status-modal-content" }
const _hoisted_334 = { class: "modal-body text-center p-0" }
const _hoisted_335 = {
  key: 0,
  class: "status-loading"
}
const _hoisted_336 = {
  key: 1,
  class: "status-card"
}
const _hoisted_337 = { key: 0 }
const _hoisted_338 = { key: 1 }
const _hoisted_339 = { key: 2 }
const _hoisted_340 = { class: "status-title mt-15 mb-5" }
const _hoisted_341 = { class: "status-checkout-id mb-20" }
const _hoisted_342 = { class: "status-amount" }
const _hoisted_343 = { class: "status-table mt-20" }
const _hoisted_344 = { id: "header_receipt" }
const _hoisted_345 = { style: {"padding":"2% 5% 2% 5%","color":"#fff"} }
const _hoisted_346 = { id: "header_text" }
const _hoisted_347 = { id: "body_receipt" }
const _hoisted_348 = { id: "body_first_section" }
const _hoisted_349 = { key: 0 }
const _hoisted_350 = { class: "section_label" }
const _hoisted_351 = { class: "section_content" }
const _hoisted_352 = { class: "section_label" }
const _hoisted_353 = { class: "section_content" }
const _hoisted_354 = { class: "section_label" }
const _hoisted_355 = { class: "section_content" }
const _hoisted_356 = { class: "section_label" }
const _hoisted_357 = { class: "section_content" }
const _hoisted_358 = { style: {"margin-top":"10%"} }
const _hoisted_359 = { class: "section_label" }
const _hoisted_360 = { class: "section_content_other" }
const _hoisted_361 = { id: "body_second_section" }
const _hoisted_362 = { class: "section_label" }
const _hoisted_363 = { class: "section_content_other1" }
const _hoisted_364 = { class: "section_label" }
const _hoisted_365 = { class: "section_content_other1" }
const _hoisted_366 = { id: "body_third_section" }
const _hoisted_367 = { class: "section_label" }

import { ref, onMounted, onBeforeUnmount, reactive, inject, nextTick, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import { Modal } from 'bootstrap';
import router from '../../../router/index';
import { current_permissions } from '../../../utils/permission';
import { redirect } from '../../../utils/services';
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from 'intl-tel-input';
import { showToast, validate_phone_number, checkSessionValidate } from "@/utils/function";
import { Business, Transaction } from "@/utils/Model";

declare interface Organization {
  id: string;
  code: string;
  name: string;
  description: string;
  email: string;
  created_at: string;
}

declare interface Operator {
  id: string;
  code: string;
  mnoName: string;
  status: string;
  countryCode: string;
}

const leadPlaceholder = "Select date";

export default /*@__PURE__*/_defineComponent({
  __name: 'TransfertsContent',
  setup(__props) {

const PDFReceipt = ref<HTMLElement | null>(null);
let role: string | null = localStorage.getItem('role');

const isPrivilegedRole = role === 'SUPERADMIN' || role === 'BUSINESS' || role === 'SUPPORT';

const isSuperAdmin = role === 'SUPERADMIN';

const backApi = inject('back');
const frontApi = inject('front');
const { t } = useI18n();

let url = '';
let urlshow = backApi + '/secure/transactions';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

const exportUrl = backApi + '/secure/transactions';

const businessMessage = ref('');
const business = ref(new Array<Business>());
const subBusiness = ref(new Array<Business>());
let businessTemp = new Array<Business>();
let iti: any;
const errors = ref('');
const errorId = ref('');
const errorsBis = { contact: '', amount: '', description: '', name: '' };
const formValues = reactive({
  contact: "",
  amount: "",
  description: "",
  name: ""
});

let codeOrganization: string | null = localStorage.getItem('organization_code');
const organization_name = localStorage.getItem('organization_name');
const email = localStorage.getItem('email');
let account_size = parseFloat(localStorage.getItem('account_size') + '');
let personnal_account_status = localStorage.getItem('personnal_account_status');

const schema = yup.object({
  contact: yup.string().required('Le numéro de téléphone est requis'),
  amount: yup.number()
    .typeError('Le montant doit être un nombre')
    .required('Le montant est requis')
    .moreThan(0, 'Le montant doit être supérieur à 0'),
  description: yup.string(),
  name: yup.string()
});

let data: any[] = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
let phone_number = ref('');

const token = localStorage.getItem('login_token');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const selectedPaymentStatus = ref('');
const selectedBusiness = ref(null);
const loader = ref(false);
const page = ref(1);
const total = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref('');
const screenSelected = ref('');
const btnLoad = ref(true);
const btnLoad1 = ref(true);
const payoutBalance = ref(0);
let balance: number = 0;
let country_code = 'ci';
let phone_length = 0;
const transactions = ref(new Array<Transaction>());
const transaction1s = ref(new Array<Transaction>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
let operatorsTemp = new Array<Operator>();
const transaction = ref({} as Transaction);
let link = ref('');
let result = ref(0);
let selectedValidationType = ref('SIMPLE');

const exportEmpty = ref(false);

// Tous les filtres de Postman
const filterCheckoutId = ref('');
const filterPayoutId = ref('');
const filterAmount = ref('');
const filterUser = ref('');
const filterTransactionDate = ref('');
const filterCount = ref('');
const filterOrder = ref('');
const filterPlatform = ref('');

const changeStatusCheckoutId = ref('');
const newStatusValue = ref('');
const newPaymentStatusValue = ref('');
const btnLoadStatus = ref(true);
const changeStatusError = ref('');

const newDescriptionValue = ref('');
const newStateValue = ref('');
const stateError = ref('');

const statusDetails = ref<any>({});
const statusLoading = ref(false);

// ═══ Onglets actifs ═══
const activeFilterTab = ref<'base' | 'advanced'>('base');
const activeDetailTab = ref<'main' | 'advanced'>('main');

// ═══ Menu d'actions flottant ═══
const openMenuId = ref<string | null>(null);
const menuPosition = ref({ top: 0, left: 0 });
let menuOpenedAt = 0;

const currentMenuTransaction = computed(() => {
  if (!openMenuId.value) return null;
  return findTransactionInList(openMenuId.value) ?? null;
});

function toggleActionMenu(event: MouseEvent, payoutId: string) {
  if (openMenuId.value === payoutId) {
    closeActionMenu();
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();
  const menuWidth = 220;

  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  if (left + menuWidth > window.innerWidth - 8) {
    left = window.innerWidth - menuWidth - 8;
  }

  menuPosition.value = { top: rect.bottom + 4, left };
  openMenuId.value = payoutId;
  menuOpenedAt = Date.now();

  nextTick(() => {
    const menuEl = document.querySelector('.action-menu-fixed') as HTMLElement | null;
    if (!menuEl) return;
    const menuHeight = menuEl.offsetHeight;

    let top = rect.bottom + 4;
    if (top + menuHeight > window.innerHeight - 8) {
      top = rect.top - menuHeight - 4;
    }
    if (top < 8) top = 8;

    menuPosition.value = { ...menuPosition.value, top };
  });
}

function closeActionMenu() {
  openMenuId.value = null;
}

function handleGlobalClick(e: MouseEvent) {
  if (!openMenuId.value) return;
  const target = e.target as HTMLElement;
  if (target.closest('.action-menu-fixed') || target.closest('.dropdown-toggle')) {
    return;
  }
  closeActionMenu();
}

function handleGlobalScroll() {
  if (!openMenuId.value) return;
  if (Date.now() - menuOpenedAt < 300) return;
  closeActionMenu();
}

const isFilled = (v: any) => v !== '' && v !== null && v !== undefined;

const activeBaseFiltersCount = computed(() => {
  return [
    selectedOrganization.value,
    selectedOperator.value,
    selectedStatus.value,
    selectedPaymentStatus.value,
    beginDate.value,
    endDate.value,
    filterAmount.value,
    filterTransactionDate.value,
  ].filter(isFilled).length;
});

const activeAdvancedFiltersCount = computed(() => {
  return [
    filterCheckoutId.value,
    filterUser.value,
    filterCount.value,
    filterOrder.value,
    filterPlatform.value,
    phone_number.value,
    filterPayoutId.value,
  ].filter(isFilled).length;
});

function blockInvalidAmountKeys(event: KeyboardEvent) {
  if (['-', '+', 'e', 'E', ',', '.'].includes(event.key)) {
    event.preventDefault();
  }
}

function sanitizeAmountValue(value: string): number {
  let numericValue = (value || '').toString().replace(/[^0-9]/g, '');
  numericValue = numericValue.replace(/^0+(?=\d)/, '');
  return numericValue === '' ? 0 : parseInt(numericValue, 10);
}

function sanitizeAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  amount.value = parsed;
  tag.value = parsed === 0 ? '' : String(parsed);
}

function sanitizeSendMoneyAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  formValues.amount = parsed === 0 ? '' : String(parsed);
  tag.value = formValues.amount;
}

function sanitizeFilterAmount(value: string, tag: HTMLInputElement) {
  const parsed = sanitizeAmountValue(value);
  filterAmount.value = parsed === 0 ? '' : String(parsed);
  tag.value = filterAmount.value;
}

const onStateInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let val = input.value;

  val = val.replace(/[^0-9]/g, '');

  if (val.length > 1) {
    val = val.slice(0, 1);
  }

  if (val !== '' && parseInt(val, 10) > 5) {
    val = '5';
  }

  newStateValue.value = val;
  input.value = val;

  if (val === '') {
    stateError.value = '';
  } else if (parseInt(val, 10) > 5) {
    stateError.value = 'La valeur ne peut pas dépasser 5.';
  } else {
    stateError.value = '';
  }
};

function hasValue(value: any): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === '—' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  if (typeof value === 'number' && isNaN(value)) return false;
  return true;
}

function formatDateTimeFr(value: string | null | undefined): string {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function formatDateFr(value: Date): string {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
  return '';
}

function formatDateEn(value: Date, d: number = 0): string {
  if (value) {
    const newDate = new Date(value);
    newDate.setDate(newDate.getDate() + d);

    const year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    const monthStr = month < 10 ? '0' + month : String(month);
    let day = newDate.getDate();
    const dayStr = day < 10 ? '0' + day : String(day);
    return year + '-' + monthStr + '-' + dayStr;
  }
  return '';
}

function truncateDescription(text: string, maxLength: number = 25): string {
  if (!text) return text;
  return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
}

function buildFilterParams(extra: Record<string, any> = {}) {
  const params = new URLSearchParams();

  const filters: Record<string, any> = {
    dateD: beginDate.value,
    dateF: endDate.value,
    count: filterCount.value,
    operator: selectedOperator.value,
    status: selectedStatus.value,
    paymentStatus: selectedPaymentStatus.value,
    amount: filterAmount.value,
    checkoutId: filterCheckoutId.value,
    transactionDate: filterTransactionDate.value,
    ordre: filterOrder.value,
    platform: filterPlatform.value,
    user: filterUser.value,
    organization: selectedOrganization.value,
    contact: phone_number.value,
    payoutId: filterPayoutId.value,
  };

  Object.assign(filters, extra);

  if (!isPrivilegedRole) {
    delete filters.checkoutId;
    delete filters.payoutId;
    delete filters.platform;
    delete filters.user;
    delete filters.ordre;
    delete filters.count;
    delete filters.contact;
  }

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== '') {
      params.append(key, value);
    }
  });

  return params.toString();
}

function buildExportParams(page: number) {
  const extra: Record<string, any> = {
    page,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  };

  if (endDate.value !== '') {
    extra.dateF = formatDateEn(new Date(endDate.value), 1);
  }

  return buildFilterParams(extra);
}

function resetFilters() {
  filterCheckoutId.value = '';
  filterPayoutId.value = '';
  filterAmount.value = '';
  filterUser.value = '';
  filterTransactionDate.value = '';
  filterCount.value = '';
  filterOrder.value = '';
  filterPlatform.value = '';
  selectedOrganization.value = '';
  selectedOperator.value = '';
  selectedStatus.value = '';
  selectedPaymentStatus.value = '';
  selectedBusiness.value = null;
  phone_number.value = '';
  beginDate.value = '';
  endDate.value = '';
  exportEmpty.value = false;

  const organizationEl = document.getElementById('organization') as HTMLSelectElement | null;
  if (organizationEl) organizationEl.value = '';
  const operatorEl = document.getElementById('operator') as HTMLSelectElement | null;
  if (operatorEl) operatorEl.value = '';
  const statusEl = document.getElementById('status') as HTMLSelectElement | null;
  if (statusEl) statusEl.value = '';
  const paymentStatusEl = document.getElementById('paymentStatus') as HTMLSelectElement | null;
  if (paymentStatusEl) paymentStatusEl.value = '';
}

function handlePhone(myvalue: string, tag: any) {
  country_code = iti.getSelectedCountryData().iso2;
  phone_length = 0;
  switch (country_code) {
    case 'ci':
      phone_length = parseInt(process.env.VUE_APP_CI_PHONE_LENTGH || '10');
      break;
    case 'sn':
      phone_length = parseInt(process.env.VUE_APP_SN_PHONE_LENTGH || '9');
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length);
}

function handleBusinessChange(event: any) {
  selectedBusiness.value = event.target.value;
  let temp = businessTemp.filter(item => item.code == selectedBusiness.value);
  if (temp.length > 0 && temp[0].validatePayoutBeforProcess == true) {
    businessMessage.value = "NB: cette catégorie nécessite toujours une validation d'un utilisateur autorisé";
  } else {
    businessMessage.value = "";
  }
  subBusiness.value = [];
  let businessArr = new Array<Business>();
  for (let j = 0; j < businessTemp.length; j++) {
    if (businessTemp[j].parent?.code == event.target.value) {
      businessArr.push(businessTemp[j]);
    }
  }
  if (businessArr.length > 0) {
    subBusiness.value = businessArr;
  }
}

function handleSubBusinessChange(event: any) {
  selectedBusiness.value = event.target.value;
  let temp = businessTemp.filter(item => item.code == selectedBusiness.value);
  if (temp.length > 0 && temp[0].validatePayoutBeforProcess == true) {
    businessMessage.value = "Cette catégorie nécessite toujours une validation d'un utilisateur autorisé";
  } else {
    businessMessage.value = "";
  }
}

function handleValidationTypeChange(event: any) {
  selectedValidationType.value = event.target.value;
}

function handleOrganizationChange(event: any) {
  selectedOrganization.value = event.target.value;
}

function handleOperatorChange(event: any) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event: any) {
  selectedStatus.value = event.target.value;
}

function handlePaymentStatusChange(event: any) {
  selectedPaymentStatus.value = event.target.value;
}

function initOperator(myvalue: string, tag: any) {
  country_code = iti.getSelectedCountryData().iso2;
  let operatorArr = new Array<Operator>();
  for (let j = 0; j < operatorsTemp.length; j++) {
    if (operatorsTemp[j].countryCode == country_code.toUpperCase()) {
      operatorArr.push(operatorsTemp[j]);
    }
  }
  operators.value = operatorArr;
}

onMounted(() => {
  checkSessionValidate(1);

  beginDate.value = formatDateEn(new Date());
  endDate.value = formatDateEn(new Date());

  if (account_size > 0 && personnal_account_status == "ACTIVE") {
    getTransfertBalancePerso();
  } else {
    getBalancePayout();
  }

  getTransactions();
  getOrganizations();
  getOperators();
  getBusiness();

  setTimeout(function () {
    flatpickr("#lead-calendar", {
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
      defaultDate: "today",
      enableTime: true,
    });
  }, 1000);

  const inputc = document.querySelector("#contact");
  iti = intlTelInput(inputc, {
    onlyCountries: ["ci", "sn"],
    initialCountry: "auto",
    geoIpLookup: function (callback) {
      fetch("https://ipapi.co/json")
        .then(function (res) { return res.json(); })
        .then(function (data) { callback(data.country_code); })
        .catch(function () { callback("ci"); });
    }
  });

  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.addEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('scroll', handleGlobalScroll, true);
});

onBeforeUnmount(() => {
  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.removeEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('scroll', handleGlobalScroll, true);
});

const usercode = localStorage.getItem('code');

const getBusiness = (arg: number = 1) => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `?organization=${codeOrganization}`;
  axios.get(backApi + '/secure/business/' + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      businessTemp = response.data;
      getBusinessParent(businessTemp);
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getBusinessParent = (businessParents: any[]) => {
  let businessArr = new Array<Business>();
  for (let j = 0; j < businessParents.length; j++) {
    if (businessParents[j].parent == null) {
      businessArr.push(businessParents[j]);
    }
  }
  business.value = businessArr;
}

const getTransfertBalancePerso = () => {
  axios.post(backApi + '/secure/accounts/balance/main', {
    user: usercode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          // router.push('/')
        }
      }
    });
}

const loadTransaction = (code: string) => {
  // Réinitialiser sur l'onglet principal
  activeDetailTab.value = 'main';

  axios.get(`${urlshow}/${code}/payout`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      transaction.value = response.data;
      operator.value = response.data.operator.mnoName;
      amount.value = response.data.amount.toLocaleString();
      paymentStatus.value = response.data.paymentStatus;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

function findTransactionInList(payoutId: string) {
  return transactions.value.find((t: any) => t.payoutId === payoutId)
      || transaction1s.value.find((t: any) => t.payoutId === payoutId);
}

function refreshCurrentList() {
  if (search.value) {
    searchTransaction(page.value);
  } else if (search1.value) {
    searchTransaction1({ target: {} }, page.value);
  } else {
    getTransactions(page.value);
  }
}

function handleStatusModalClosed() {
  refreshCurrentList();
}

function handleShowStatus(payoutId: string) {
  closeActionMenu();
  statusLoading.value = true;
  statusDetails.value = {};

  const modalEl = document.getElementById('transactionStatusModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();

  axios.get(`${backApi}/secure/transactions/${payoutId}/payout/status`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    const raw = response.data;
    statusDetails.value = Array.isArray(raw) ? (raw[0] ?? {}) : (raw ?? {});
    statusLoading.value = false;
  }).catch((error) => {
    statusLoading.value = false;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        showToast(error.response?.data?.message ?? "Erreur lors de la récupération du statut", "red");
      }
    }
  });
}

const isSuccessPaymentStatus = (value: string) => value === 'SUCCEEDED' || value === 'SUCCESS';
const isFailedPaymentStatus = (value: string) => value === 'FAILED';

const statusIconClass = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'status-icon-success';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'status-icon-failed';
  return 'status-icon-pending';
});

const statusLabelText = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'Transaction réussie';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'Transaction échouée';
  switch (statusDetails.value.paymentStatus) {
    case 'PROCESSING': return 'Transaction en cours';
    case 'PENDING': return 'Transaction en attente';
    default: return statusDetails.value.paymentStatus ? 'Statut : ' + statusDetails.value.paymentStatus : 'Statut inconnu';
  }
});

const techStatusClass = computed(() => statusDetails.value.status === 'COMPLETED' ? 'pill-completed' : 'pill-open');

const paymentStatusClass = computed(() => {
  if (isSuccessPaymentStatus(statusDetails.value.paymentStatus)) return 'pill-success';
  if (isFailedPaymentStatus(statusDetails.value.paymentStatus)) return 'pill-failed';
  return 'pill-pending';
});


/**
 * Retourne le libellé traduit d'un statut de paiement.
 */
function getPaymentStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  switch (status.toUpperCase()) {
    case 'SUCCEEDED':
    case 'SUCCESS':
      return t('transactions.success');
    case 'FAILED':
      return t('transactions.failed');
    case 'PROCESSING':
      return t('transactions.processing');
    case 'PENDING':
      return t('transactions.pending');
    case 'INITIATED':
      return t('transactions.initiated');
    case 'SCHEDULED':
      return t('transactions.scheduled');
    default:
      return status;
  }
}

function getPaymentStatusClass(status: string | null | undefined): string {
  if (!status) return 'badge text-outline-secondary';
  switch (status.toUpperCase()) {
    case 'SUCCEEDED':
    case 'SUCCESS':
      return 'badge text-outline-success';
    case 'FAILED':
      return 'badge text-outline-danger';
    case 'PROCESSING':
      return 'badge text-outline-info';
    case 'PENDING':
      return 'badge text-outline-warning';
    case 'INITIATED':
      return 'badge text-outline-primary';
    case 'SCHEDULED':
      return 'badge text-outline-secondary';
    default:
      return 'badge text-outline-secondary';
  }
}

function handleChangeStatus(payoutId: string) {
  closeActionMenu();
  const found = findTransactionInList(payoutId);

  changeStatusCheckoutId.value = (found as any)?.code ?? payoutId;

  newStatusValue.value = (found as any)?.status ?? '';
  newPaymentStatusValue.value = (found as any)?.paymentStatus ?? '';

  newDescriptionValue.value = (found as any)?.description ?? '';
  newStateValue.value = (found as any)?.state != null ? String((found as any).state) : '';
  stateError.value = '';

  changeStatusError.value = '';

  const modalEl = document.getElementById('changeStatusModal');
  if (modalEl) {
    Modal.getOrCreateInstance(modalEl).show();
  }
}

function submitChangeStatus() {
  changeStatusError.value = '';

  if (!changeStatusCheckoutId.value) {
    changeStatusError.value = "Le code de la transaction est requis.";
    return;
  }

  const payload: any = { code: changeStatusCheckoutId.value };
  if (newStatusValue.value) payload.status = newStatusValue.value;
  if (newPaymentStatusValue.value) payload.paymentStatus = newPaymentStatusValue.value;

  if (newDescriptionValue.value && newDescriptionValue.value.trim() !== '') {
    payload.description = newDescriptionValue.value.trim();
  }
  if (newStateValue.value !== '' && newStateValue.value !== null) {
    payload.state = parseInt(newStateValue.value, 10);
  }

  btnLoadStatus.value = false;

  axios.post(`${backApi}/secure/transactions/status`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadStatus.value = true;
    showToast("Statut mis à jour", "green");
    const modalEl = document.getElementById('changeStatusModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();

    if (search.value) {
      searchTransaction(page.value);
    } else if (search1.value) {
      searchTransaction1({ target: {} }, page.value);
    } else {
      getTransactions(page.value);
    }
  }).catch((error) => {
    btnLoadStatus.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
        showToast(error.response.data.message, "red");
      }
    }
  });
}

const getTransactions = (arg: number = 1) => {
  loader.value = false;
  gettran.value = true;
  search.value = false;
  search1.value = false;

  if (beginDate.value === '') {
    beginDate.value = formatDateEn(new Date());
  }
  if (endDate.value === '') {
    endDate.value = formatDateEn(new Date());
  }
  const todayE = formatDateEn(new Date(endDate.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: beginDate.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);

      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const getOperators = () => {
  axios.get(backApi + '/secure/operators/available/' + process.env.VUE_APP_PAYOUT_OPTTYPE, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      operatorsTemp = response.data;
      operators.value = operatorsTemp.filter(
        (op) => op.countryCode === country_code.toUpperCase()
      );
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const exportExcel = () => {
  import("../../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE TRANSACTION", "OPERATEUR", "TELEPHONE", "MONTANT", "DATE", "STATUT"];
    const Fields = ["payoutId", "operator_name", "contact", "amount", "transactionDate", "paymentStatus"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "transactions",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData: string[], JsonData: any[]) {
  return JsonData.map((v) => FilterData.map((j) => {
    return v[j];
  }));
}

const searchTransactionExportToPDF = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const queryParams = buildExportParams(1);

    axios.get(`${exportUrl}/list/export?${queryParams}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        if (response.status === 200) {
          const result = response.data;
          if (!result || result.length === 0) {
            transaction1s.value = [];
            exportEmpty.value = true;
            showToast("Aucune transaction trouvée pour ces critères, export impossible", "red");
            resolve(false);
            return;
          }
          exportEmpty.value = false;
          transaction1s.value = result;
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/');
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        resolve(false);
      });
  });
}

const exportToPDF = async () => {
  btnLoad1.value = false;

  const hasData = await searchTransactionExportToPDF();

  if (!hasData) {
    btnLoad1.value = true;
    return;
  }

  await nextTick();

  const tableElement = document.getElementById("transactionsTable");
  if (!tableElement) {
    btnLoad1.value = true;
    return;
  }

  tableElement.style.display = 'block';
  const opt = {
    margin: [0, 0, 0, 0],
    filename: "transactions.pdf",
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }
  };

  html2pdf().set(opt).from(tableElement).toPdf().get('pdf').then(function (pdf) {
    window.open(pdf.output('bloburl'), '_blank');
    tableElement.style.display = 'none';
    btnLoad1.value = true;
  }).catch(() => {
    tableElement.style.display = 'none';
    btnLoad1.value = true;
  });
}

const searchTransaction = (arg: number = 1) => {
  loader.value = false;
  gettran.value = false;
  search.value = true;
  search1.value = false;

  if (beginDate.value === '') {
    beginDate.value = formatDateEn(new Date());
  }
  if (endDate.value === '') {
    endDate.value = formatDateEn(new Date(), 1);
  }
  const todayE = formatDateEn(new Date(endDate.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: beginDate.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);
      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const searchTransaction1 = (event: any, arg: number = 1) => {
  if (typeof event.target.value !== 'undefined') {
    today.value = event.target.value;
  }

  loader.value = false;
  gettran.value = false;
  search.value = false;
  search1.value = true;

  const todayE = formatDateEn(new Date(today.value), 1);

  const queryParams = buildFilterParams({
    page: arg,
    dateD: today.value,
    dateF: todayE,
    operationType: process.env.VUE_APP_PAYOUT_OPTTYPE || '1',
  });

  axios.get(`${url}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data.data;
      total.value = parseInt(response.data.pagination.total);
      page.value = parseInt(response.data.pagination.currentPage);
      numPages.value = parseInt(response.data.pagination.numPages);
      for (let pas = 0; pas < data.length; pas++) {
        data[pas].operator_name = data[pas].operator.mnoName;
        data[pas].description = truncateDescription(data[pas].description, 25);
      }
      transactions.value = data;
      loader.value = true;
    })
    .catch((error) => {
      loader.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const sendMoney = () => {
  btnLoad.value = false;

  const sendAmount = parseFloat(formValues.amount);

  if (sendAmount > 0 && sendAmount <= balance && selectedOperator.value !== '' && formValues.contact.length == phone_length) {
    try {
      schema.validateSync(formValues);
      axios.post(`${backApi}/secure/transactions/init`, {
        operator: selectedOperator.value,
        amount: formValues.amount,
        mobile: formValues.contact,
        operationType: parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE || '1'),
        countryCode: country_code,
        business: selectedBusiness.value,
        description: formValues.description,
        clientId: formValues.name,
        successUrl: "https://billing.api/success",
        errorUrl: "https://billing.api/error"
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 201) {
          showToast("Transfert réussi", "green");
          formValues.amount = '';
          formValues.contact = '';
          selectedOperator.value = '';
          selectedBusiness.value = null;
        }
        router.go();
      }).catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/');
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
      });
    } catch (error) {
      btnLoad.value = true;
      errors.value = "une erreur inattendue est apparue";
    }
  } else {
    if (isNaN(sendAmount) || sendAmount <= 0) {
      showToast("Veuillez saisir un montant correct", "red");
    }
    if (sendAmount > balance) {
      showToast("Solde insuffisant pour cette opération", "red");
    }
    if (selectedOperator.value == '') {
      showToast("Veuillez sélectionner un opérateur", "red");
    }
    if (formValues.contact.length != phone_length) {
      showToast("Veuillez saisir un numéro de téléphone correct", "red");
    }
    btnLoad.value = true;
  }
}

function validate(field: string) {
  schema.validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

const searchTransactionForExport = () => {
  btnLoad.value = false;

  const queryParams = buildExportParams(1);

  axios.get(`${exportUrl}/list/export?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        data = response.data;

        if (!data || data.length === 0) {
          exportEmpty.value = true;
          showToast("Aucune transaction trouvée pour ces critères, export impossible", "red");
          return;
        }

        exportEmpty.value = false;
        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
        }
        exportExcel();
      }
    })
    .catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
}

const showScreen = (screen: string) => {
  screenSelected.value = screen;
  selectedBusiness.value = null;
  selectedOperator.value = '';
  selectedStatus.value = '';
  selectedPaymentStatus.value = '';
  exportEmpty.value = false;

  // Réinitialiser sur l'onglet principal
  activeFilterTab.value = 'base';

  if (screen === 'excel') {
    beginDate.value = '';
    endDate.value = '';
  }
}

const getBalancePayout = () => {
  axios.post(backApi + `/secure/accounts/balance/main`, {
    organization: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

const generateLink = () => {
  errors.value = '';
  errorId.value = '';

  const linkAmount = parseFloat(amount.value as any);

  if (isNaN(linkAmount) || linkAmount <= 0) {
    showToast("Le montant doit être supérieur à 0", "red");
    errors.value = "Le montant doit être supérieur à 0";
    return;
  }

  if (linkAmount > balance) {
    showToast("Solde insuffisant pour générer ce lien de paiement", "red");
    errors.value = "Solde insuffisant pour générer ce lien de paiement";
    return;
  }

  btnLoad.value = false;

  try {
    axios.post(`${backApi}/secure/transactions/token`, {
      amount: amount.value,
      operationType: process.env.VUE_APP_PAYOUT_OPTTYPE,
      validationType: selectedValidationType.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 201) {
        link.value = response.data.ticketUrl;
        result.value = 1;
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue";
  }
}

function copyToCliboard() {
  var copyText = document.getElementById("link") as HTMLInputElement;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

function copyToShare(publictoken: string) {
  let copyText = `${frontApi}/ticket/payout/${publictoken}`;
  navigator.clipboard.writeText(copyText);
  showToast("Lien copié avec succès", "green");
  closeActionMenu();
}

function reset() {
  amount.value = 0;
  link.value = '';
  result.value = 0;
  selectedValidationType.value = 'SIMPLE';
}

// ═══ Handlers du menu d'actions ═══
function handleView(payoutId: string) {
  loadTransaction(payoutId);
  closeActionMenu();
  activeDetailTab.value = 'main';
  const modalEl = document.getElementById('companyModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleReceipt(payoutId: string) {
  closeActionMenu();
  download_receipt(payoutId);
}

const download_receipt = (payoutId: string) => {
  loadTransaction(payoutId);

  const element = PDFReceipt.value;
  element?.classList.remove("d-none");

  document.getElementById("back")?.classList.add("d-none");
  setTimeout(() => {
    document.getElementById("receipt").style.display = 'block';

    const opt = {
      margin: [0, 0, 0, 0],
      filename: "receipt_" + transaction.value.payoutId + ".pdf",
      jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" },
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
    };
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save();
  }, 3000);
  setTimeout(() => {
    element?.classList.add("d-none");
    document.getElementById("back")?.classList.remove("d-none");
  }, 3000);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[73] || (_cache[73] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('get_transaction'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showScreen('excel'))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#filterLeadModal"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('transfers.export')) + " ", 1),
                    _cache[74] || (_cache[74] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _cache[75] || (_cache[75] = _createTextVNode("      ", -1)),
              (_unref(current_permissions)('create_public_token'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(_ctx.$t('transfers.paymentLink')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(today) ? (today).value = $event : today = $event)),
                    type: "date",
                    class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    id: "lead-calendar",
                    placeholder: leadPlaceholder,
                    onChange: searchTransaction1
                  }, null, 544), [
                    [_vModelText, _unref(today)]
                  ])
                ])
              ]),
              (_unref(current_permissions)('init_checkout'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    style: {"width":"max-content"},
                    type: "button",
                    class: "default-btn d-block text-center w-100 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(redirect)('/multi-transferts')))
                  }, _toDisplayString(_ctx.$t('transfers.multipleSend')), 1))
                : _createCommentVNode("", true),
              _cache[77] || (_cache[77] = _createTextVNode("       ", -1)),
              (_unref(current_permissions)('init_checkout'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_8, _toDisplayString(_ctx.$t('transfers.singleSend')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0 ms-2",
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": "#filterLeadModal",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showScreen('search')))
              }, [...(_cache[76] || (_cache[76] = [
                _createElementVNode("svg", {
                  width: "25",
                  height: "25",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
                ], -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('transfers.code')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('transfers.beneficiary')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('transfers.description')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('transfers.operator')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('transfers.phone')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('transfers.amount')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('transfers.date')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('transfers.status')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('transfers.validation')), 1),
                    _cache[78] || (_cache[78] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.payoutId
                    }, [
                      _createElementVNode("th", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              (transaction.publicToken!=null)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(transaction.payoutId), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(transaction.clientId), 1),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        title: transaction.description
                      }, _toDisplayString(transaction.description), 9, _hoisted_28),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(transaction.operator.mnoName), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(transaction.contact), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(transaction.amount.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(formatDateFr(new Date(transaction.transactionDate))), 1),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("span", {
                          class: _normalizeClass(getPaymentStatusClass(transaction.paymentStatus))
                        }, _toDisplayString(getPaymentStatusLabel(transaction.paymentStatus)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        (transaction.validationStatus==='DRAFT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('transfers.draft')), 1))
                          : (transaction.validationStatus==='VALIDATED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('transfers.validated')), 1))
                            : (transaction.validationStatus==='REJECTED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('transfers.rejected')), 1))
                              : (transaction.publicTokenValidationStatus==='DRAFT')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('transfers.draft')), 1))
                                : (transaction.publicTokenValidationStatus==='VALIDATED')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('transfers.validated')), 1))
                                  : (transaction.publicTokenValidationStatus==='REJECTED')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('transfers.rejected')), 1))
                                    : (transaction.publicTokenValidationStatus==='SUCCEEDED')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('transactions.success')), 1))
                                      : (transaction.publicTokenValidationStatus==='FAILED')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('transactions.failed')), 1))
                                        : (transaction.publicTokenValidationStatus==='PROCESSING')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('transactions.processing')), 1))
                                          : (transaction.publicTokenValidationStatus==='PENDING')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('transactions.pending')), 1))
                                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          onClick: ($event: any) => (toggleActionMenu($event, transaction.payoutId))
                        }, [...(_cache[79] || (_cache[79] = [
                          _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                        ]))], 8, _hoisted_46)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(organization_name)), 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('transfers.editionDate')) + " " + _toDisplayString(formatDateFr(new Date())), 1),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(email)), 1)
                ]),
                _cache[80] || (_cache[80] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("h2", _hoisted_52, _toDisplayString(_ctx.$t('transfers.listTitle')), 1),
                  _createElementVNode("h5", _hoisted_53, _toDisplayString(_ctx.$t('transfers.period')) + " " + _toDisplayString(_unref(beginDate) ? formatDateFr(new Date((_unref(beginDate)))) : _ctx.$t('transfers.all')) + " " + _toDisplayString(_ctx.$t('transfers.to')) + " " + _toDisplayString(_unref(endDate) ? formatDateFr(new Date((_unref(endDate)))) : _ctx.$t('transfers.all')), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("table", _hoisted_55, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('transfers.code')), 1),
                        _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.$t('transfers.operator')), 1),
                        _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.$t('transfers.phone')), 1),
                        _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.$t('transfers.amount')), 1),
                        _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.$t('transfers.date')), 1),
                        _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.$t('transfers.status')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction1s.value, (transaction1) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: transaction1.payoutId
                        }, [
                          _createElementVNode("th", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, _toDisplayString(transaction1.payoutId), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_65, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.operator.mnoName), 1)
                          ]),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(transaction1.contact), 1),
                          _createElementVNode("td", _hoisted_67, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.amount.toLocaleString()), 1)
                          ]),
                          _createElementVNode("td", _hoisted_68, _toDisplayString(formatDateFr(new Date(transaction1.transactionDate))), 1),
                          _createElementVNode("td", _hoisted_69, _toDisplayString(getPaymentStatusLabel(transaction1.paymentStatus)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  (total.value>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transfers.showing')) + " ", 1),
                        (total.value>page.value*10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(page.value*10), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(total.value), 1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_74, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (total.value<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_75, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transfers.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_76, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (gettran.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_78, [
                        _createElementVNode("ul", _hoisted_79, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_80, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (getTransactions(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[81] || (_cache[81] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_81, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (getTransactions(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_82))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (getTransactions(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[82] || (_cache[82] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (search.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_84, [
                        _createElementVNode("ul", _hoisted_85, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_86, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (searchTransaction(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[83] || (_cache[83] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_87, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (searchTransaction(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_88))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_89, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (searchTransaction(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[84] || (_cache[84] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (search1.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_90, [
                        _createElementVNode("ul", _hoisted_91, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (searchTransaction1($event,page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[85] || (_cache[85] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_93, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (searchTransaction1($event,numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_94))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_95, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (searchTransaction1($event,page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[86] || (_cache[86] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (openMenuId.value)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: "dropdown-menu show action-menu-fixed",
            style: _normalizeStyle({ top: menuPosition.value.top + 'px', left: menuPosition.value.left + 'px' }),
            onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (handleView(openMenuId.value))),
                href: "javascript:void(0);",
                class: "dropdown-item d-flex align-items-center"
              }, [
                _cache[87] || (_cache[87] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.view')), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (handleReceipt(openMenuId.value))),
                href: "javascript:void(0);",
                class: "dropdown-item d-flex align-items-center"
              }, [
                _cache[88] || (_cache[88] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.downloadReceipt')), 1)
              ])
            ]),
            isSuperAdmin
              ? (_openBlock(), _createElementBlock("li", _hoisted_96, [
                  _createElementVNode("a", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (handleShowStatus(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [...(_cache[89] || (_cache[89] = [
                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Statut réel ", -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            (currentMenuTransaction.value && currentMenuTransaction.value.publicToken != null && currentMenuTransaction.value.validationStatus === 'DRAFT')
              ? (_openBlock(), _createElementBlock("li", _hoisted_97, [
                  _createElementVNode("a", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (copyToShare(currentMenuTransaction.value.publicToken))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [
                    _cache[90] || (_cache[90] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.copyLink')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                target: "_blank",
                class: "dropdown-item d-flex align-items-center",
                href: "https://wa.me/message/SV5FPBLDUDCBJ1?text=urlencodedtext",
                onClick: closeActionMenu
              }, [
                _cache[91] || (_cache[91] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.claim')), 1)
              ])
            ]),
            isSuperAdmin
              ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                  _createElementVNode("a", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (handleChangeStatus(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [...(_cache[92] || (_cache[92] = [
                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Changer statut ", -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(sendMoney, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("h1", _hoisted_103, _toDisplayString(_ctx.$t('transfers.sendMoney')), 1),
              _cache[93] || (_cache[93] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("h6", _hoisted_106, _toDisplayString(_ctx.$t('transfers.balance')), 1),
                _createElementVNode("h6", _hoisted_107, _toDisplayString(payoutBalance.value?.toLocaleString()) + " XOF", 1)
              ]),
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createElementVNode("h6", _hoisted_109, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_110, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t('transfers.phone')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.contact) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['contact'] }]),
                        id: "contact",
                        placeholder: "ex: 0500457801",
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (handlePhone($event.target.value,$event.target))),
                        onFocus: _cache[18] || (_cache[18] = ($event: any) => (initOperator($event.target.value,$event.target))),
                        onKeyup: _cache[19] || (_cache[19] = ($event: any) => (handlePhone($event.target.value,$event.target))),
                        onChange: _cache[20] || (_cache[20] = ($event: any) => (validate('contact')))
                      }, null, 34), [
                        [_vModelText, formValues.contact]
                      ]),
                      _createElementVNode("span", _hoisted_115, _toDisplayString(errorsBis['contact']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.$t('transfers.operators')), 1),
                    _createElementVNode("select", {
                      name: "operator",
                      id: "operator",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleOperatorChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_118, _toDisplayString(_ctx.$t('transfers.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: operator.mnoName,
                          key: operator.code
                        }, _toDisplayString(operator.mnoName), 9, _hoisted_119))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t('transfers.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formValues.amount) = $event)),
                        type: "number",
                        min: "1",
                        step: "1",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['amount'] }]),
                        id: "amount",
                        placeholder: "2",
                        onKeydown: blockInvalidAmountKeys,
                        onKeyup: _cache[22] || (_cache[22] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target))),
                        onInput: _cache[23] || (_cache[23] = ($event: any) => (sanitizeSendMoneyAmount($event.target.value,$event.target))),
                        onBlur: _cache[24] || (_cache[24] = ($event: any) => (validate('amount')))
                      }, null, 34), [
                        [_vModelText, formValues.amount]
                      ]),
                      _createElementVNode("span", _hoisted_122, _toDisplayString(errorsBis['amount']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.$t('transfers.beneficiary')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "name",
                        placeholder: "Aka Franck",
                        onBlur: _cache[26] || (_cache[26] = ($event: any) => (validate('name')))
                      }, null, 34), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_126, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t('transfers.category')), 1),
                    _createElementVNode("select", {
                      name: "business",
                      id: "business",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleBusinessChange
                    }, [
                      _createElementVNode("option", _hoisted_129, _toDisplayString(_ctx.$t('transfers.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.value, (businessItem) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: businessItem.code,
                          key: businessItem.code
                        }, _toDisplayString(businessItem.name), 9, _hoisted_130))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('transfers.subCategory')), 1),
                    _createElementVNode("select", {
                      name: "sub_business",
                      id: "sub_business",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleSubBusinessChange
                    }, [
                      _createElementVNode("option", _hoisted_133, _toDisplayString(_ctx.$t('transfers.selectSubCategory')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subBusiness.value, (subBusinessItem) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: subBusinessItem.code,
                          key: subBusinessItem.code
                        }, _toDisplayString(subBusinessItem.name), 9, _hoisted_134))
                      }), 128))
                    ], 32)
                  ]),
                  (_unref(current_permissions)('SUPERADMIN'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t('transfers.clients')), 1),
                        _createElementVNode("select", {
                          name: "organization",
                          id: "organization",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleOrganizationChange,
                          required: ""
                        }, [
                          _createElementVNode("option", _hoisted_137, _toDisplayString(_ctx.$t('transfers.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: organization.code,
                              key: organization.id
                            }, _toDisplayString(organization.name), 9, _hoisted_138))
                          }), 128))
                        ], 32)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('transfers.description')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formValues.description) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                      id: "description",
                      onBlur: _cache[28] || (_cache[28] = ($event: any) => (validate('description')))
                    }, null, 34), [
                      [_vModelText, formValues.description]
                    ]),
                    _createElementVNode("span", _hoisted_141, _toDisplayString(errorsBis['description']), 1)
                  ]),
                  _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1)),
                  (businessMessage.value!='')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_142, _toDisplayString(businessMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_143, [
              (_unref(current_permissions)('init_checkout'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn text-white",
                    style: {"background-color":"#EB9355"},
                    disabled: !btnLoad.value
                  }, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_145))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.send')), 1)
                  ], 8, _hoisted_144))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_146, [
      _createElementVNode("div", _hoisted_147, [
        _createElementVNode("div", _hoisted_148, [
          _createElementVNode("div", _hoisted_149, [
            (screenSelected.value=='search')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_150, _toDisplayString(_ctx.$t('transfers.advancedSearch')), 1))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_151, _toDisplayString(_ctx.$t('transfers.exportTransactions')), 1))
              : _createCommentVNode("", true),
            _cache[95] || (_cache[95] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["modal-tab", { active: activeFilterTab.value === 'base' }]),
              onClick: _cache[29] || (_cache[29] = ($event: any) => (activeFilterTab.value = 'base'))
            }, [
              _cache[96] || (_cache[96] = _createTextVNode(" Critères de recherche ", -1)),
              (activeBaseFiltersCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_153, _toDisplayString(activeBaseFiltersCount.value), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_unref(isPrivilegedRole))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["modal-tab", { active: activeFilterTab.value === 'advanced' }]),
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (activeFilterTab.value = 'advanced'))
                }, [
                  _cache[97] || (_cache[97] = _createTextVNode(" Filtres avancés ", -1)),
                  (activeAdvancedFiltersCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_154, _toDisplayString(activeAdvancedFiltersCount.value), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_155, [
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                  _createElementVNode("h6", _hoisted_157, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_158, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_159, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_160, [
                  (_unref(current_permissions)('SUPERADMIN'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                        _cache[98] || (_cache[98] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Organization", -1)),
                        _createElementVNode("select", {
                          name: "organization",
                          id: "organization",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleOrganizationChange
                        }, [
                          _createElementVNode("option", _hoisted_162, _toDisplayString(_ctx.$t('transfers.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: organization.code,
                              key: organization.id
                            }, _toDisplayString(organization.name), 9, _hoisted_163))
                          }), 128))
                        ], 32)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_164, [
                    _cache[99] || (_cache[99] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Operator", -1)),
                    _createElementVNode("select", {
                      name: "operator",
                      id: "operator",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleOperatorChange
                    }, [
                      _createElementVNode("option", _hoisted_165, _toDisplayString(_ctx.$t('transfers.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: operator.mnoName,
                          key: operator.code
                        }, _toDisplayString(operator.mnoName), 9, _hoisted_166))
                      }), 128))
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _cache[102] || (_cache[102] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Status", -1)),
                    _createElementVNode("select", {
                      name: "status",
                      id: "status",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleStatusChange
                    }, [
                      _createElementVNode("option", _hoisted_169, _toDisplayString(_ctx.$t('transfers.select')), 1),
                      _cache[100] || (_cache[100] = _createElementVNode("option", { value: "COMPLETED" }, "COMPLETED", -1)),
                      _cache[101] || (_cache[101] = _createElementVNode("option", { value: "OPEN" }, "OPEN", -1))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_170, [
                    _cache[104] || (_cache[104] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Payment Status", -1)),
                    _createElementVNode("select", {
                      name: "paymentStatus",
                      id: "paymentStatus",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handlePaymentStatusChange
                    }, [
                      _createElementVNode("option", _hoisted_171, _toDisplayString(_ctx.$t('transfers.select')), 1),
                      _cache[103] || (_cache[103] = _createStaticVNode("<option value=\"SUCCEEDED\" data-v-22f1a93e>SUCCEEDED</option><option value=\"PROCESSING\" data-v-22f1a93e>PROCESSING</option><option value=\"PENDING\" data-v-22f1a93e>PENDING</option><option value=\"FAILED\" data-v-22f1a93e>FAILED</option><option value=\"INITIATED\" data-v-22f1a93e>INITIATED</option><option value=\"SCHEDULED\" data-v-22f1a93e>SCHEDULED</option>", 6))
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_172, [
                  _createElementVNode("div", _hoisted_173, [
                    _cache[105] || (_cache[105] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date Début", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(beginDate) ? (beginDate).value = $event : beginDate = $event)),
                      type: "date",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                    }, null, 512), [
                      [_vModelText, _unref(beginDate)]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _cache[106] || (_cache[106] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date Fin", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_isRef(endDate) ? (endDate).value = $event : endDate = $event)),
                      type: "date",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                    }, null, 512), [
                      [_vModelText, _unref(endDate)]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("div", _hoisted_176, [
                    _cache[107] || (_cache[107] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Amount", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((filterAmount).value = $event)),
                      type: "number",
                      min: "1",
                      step: "1",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      placeholder: "10",
                      onKeydown: blockInvalidAmountKeys,
                      onInput: _cache[34] || (_cache[34] = ($event: any) => (sanitizeFilterAmount($event.target.value,$event.target)))
                    }, null, 544), [
                      [_vModelText, filterAmount.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Transaction Date", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((filterTransactionDate).value = $event)),
                      type: "datetime-local",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                    }, null, 512), [
                      [_vModelText, filterTransactionDate.value]
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, activeFilterTab.value === 'base']
              ]),
              (_unref(isPrivilegedRole))
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("div", _hoisted_180, [
                        _cache[109] || (_cache[109] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Checkout ID", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((filterCheckoutId).value = $event)),
                          type: "text",
                          class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          placeholder: "202401221110522250595736110"
                        }, null, 512), [
                          [_vModelText, filterCheckoutId.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_181, [
                        _cache[110] || (_cache[110] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "User", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((filterUser).value = $event)),
                          type: "text",
                          class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          placeholder: "35b730c4-ad8e-436e-a2ca-833bb73d47"
                        }, null, 512), [
                          [_vModelText, filterUser.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", _hoisted_183, [
                        _cache[111] || (_cache[111] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Count", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((filterCount).value = $event)),
                          type: "number",
                          class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          placeholder: "10"
                        }, null, 512), [
                          [_vModelText, filterCount.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_184, [
                        _cache[114] || (_cache[114] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ordre", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((filterOrder).value = $event)),
                          class: "form-select fs-md-15 text-black shadow-none"
                        }, [
                          _createElementVNode("option", _hoisted_185, _toDisplayString(_ctx.$t('transfers.select')), 1),
                          _cache[112] || (_cache[112] = _createElementVNode("option", { value: "DESC" }, "DESC", -1)),
                          _cache[113] || (_cache[113] = _createElementVNode("option", { value: "ASC" }, "ASC", -1))
                        ], 512), [
                          [_vModelSelect, filterOrder.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_186, [
                        _cache[117] || (_cache[117] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Platform", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((filterPlatform).value = $event)),
                          class: "form-select fs-md-15 text-black shadow-none"
                        }, [
                          _createElementVNode("option", _hoisted_187, _toDisplayString(_ctx.$t('transfers.select')), 1),
                          _cache[115] || (_cache[115] = _createElementVNode("option", { value: "PARTNER" }, "PARTNER", -1)),
                          _cache[116] || (_cache[116] = _createElementVNode("option", { value: "ADMIN" }, "ADMIN", -1))
                        ], 512), [
                          [_vModelSelect, filterPlatform.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _createElementVNode("div", _hoisted_189, [
                        _cache[118] || (_cache[118] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Phone", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_isRef(phone_number) ? (phone_number).value = $event : phone_number = $event)),
                          type: "text",
                          class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          placeholder: "0564791896"
                        }, null, 512), [
                          [_vModelText, _unref(phone_number)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_190, [
                        _cache[119] || (_cache[119] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Payout ID", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((filterPayoutId).value = $event)),
                          type: "text",
                          class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          placeholder: "01589b-11ec-6bwx2w"
                        }, null, 512), [
                          [_vModelText, filterPayoutId.value]
                        ])
                      ])
                    ])
                  ], 512)), [
                    [_vShow, activeFilterTab.value === 'advanced']
                  ])
                : _createCommentVNode("", true),
              (screenSelected.value=='excel' && exportEmpty.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                    _createElementVNode("div", _hoisted_192, [
                      _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.$t('transfers.noResultForExport')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: _cache[43] || (_cache[43] = ($event: any) => (resetFilters()))
            }, _toDisplayString(_ctx.$t('transfers.refresh')), 1),
            (screenSelected.value=='search')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"#EB9355"},
                  "data-bs-dismiss": "modal",
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (searchTransaction(1)))
                }, [...(_cache[120] || (_cache[120] = [
                  _createElementVNode("i", {
                    class: "flaticon-search-interface-symbol",
                    style: {"color":"#FFF"}
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: !btnLoad.value,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"#EB9355"},
                  onClick: _cache[45] || (_cache[45] = ($event: any) => (searchTransactionForExport()))
                }, [
                  (!btnLoad.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_196))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_197, _toDisplayString(_ctx.$t('transfers.excel')), 1)
                ], 8, _hoisted_195))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: !btnLoad1.value,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"blue"},
                  onClick: _cache[46] || (_cache[46] = ($event: any) => (exportToPDF()))
                }, [
                  (!btnLoad1.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_199))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_200, _toDisplayString(_ctx.$t('transfers.pdf')), 1)
                ], 8, _hoisted_198))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_201, [
      _createElementVNode("div", _hoisted_202, [
        _createElementVNode("div", _hoisted_203, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_204, [
              _createElementVNode("h1", _hoisted_205, _toDisplayString(_ctx.$t('transactions.transactionDetails')) + " (" + _toDisplayString(paymentStatus.value) + ")", 1),
              _cache[121] || (_cache[121] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_206, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'main' }]),
                onClick: _cache[47] || (_cache[47] = ($event: any) => (activeDetailTab.value = 'main'))
              }, " Informations principales ", 2),
              (_unref(isPrivilegedRole))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'advanced' }]),
                    onClick: _cache[48] || (_cache[48] = ($event: any) => (activeDetailTab.value = 'advanced'))
                  }, " Informations avancées ", 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_207, [
              _createElementVNode("div", _hoisted_208, [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_209, [
                    (hasValue(transaction.value.checkoutId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                          _createElementVNode("label", _hoisted_211, _toDisplayString(_ctx.$t('transactions.transactionCode')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((transaction.value.checkoutId) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.checkoutId]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (transaction.value.paymentStatus==='SUCCEEDED' && hasValue(transaction.value.operator?.mnoName==='WAVE' ? transaction.value.providerTransactionId : transaction.value.providerTransactionReference))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                          _createElementVNode("label", _hoisted_213, _toDisplayString(_ctx.$t('transactions.operatorReference')), 1),
                          (transaction.value.operator?.mnoName!=='WAVE')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((transaction.value.providerTransactionReference) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512)), [
                                [_vModelText, transaction.value.providerTransactionReference]
                              ])
                            : _createCommentVNode("", true),
                          (transaction.value.operator?.mnoName=='WAVE')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((transaction.value.providerTransactionId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512)), [
                                [_vModelText, transaction.value.providerTransactionId]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(amount.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                          _createElementVNode("label", _hoisted_215, _toDisplayString(_ctx.$t('transactions.amount')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((amount).value = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, amount.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(transaction.value.transactionDate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                          _createElementVNode("label", _hoisted_217, _toDisplayString(_ctx.$t('transactions.date')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((transaction.value.transactionDate) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.transactionDate]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(operator.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                          _createElementVNode("label", _hoisted_219, _toDisplayString(_ctx.$t('transactions.operator')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((operator).value = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, operator.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(transaction.value.contact))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                          _createElementVNode("label", _hoisted_221, _toDisplayString(_ctx.$t('transactions.phone')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((transaction.value.contact) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.contact]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, activeDetailTab.value === 'main']
                ]),
                (_unref(isPrivilegedRole))
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_222, [
                      _createElementVNode("div", _hoisted_223, [
                        (hasValue(transaction.value.payoutId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                              _createElementVNode("label", _hoisted_225, _toDisplayString(_ctx.$t('transactions.payoutId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((transaction.value.payoutId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.payoutId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.bulkId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                              _createElementVNode("label", _hoisted_227, _toDisplayString(_ctx.$t('transactions.bulkId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((transaction.value.bulkId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.bulkId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.status))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                              _createElementVNode("label", _hoisted_229, _toDisplayString(_ctx.$t('transactions.technicalStatus')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.status,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_230)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.validationStatus))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                              _createElementVNode("label", _hoisted_232, _toDisplayString(_ctx.$t('transactions.validationStatus')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.validationStatus,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_233)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_234, [
                        (hasValue(transaction.value.statusCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                              _createElementVNode("label", _hoisted_236, _toDisplayString(_ctx.$t('transactions.statusCode')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.statusCode,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_237)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.operationType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                              _createElementVNode("label", _hoisted_239, _toDisplayString(_ctx.$t('transactions.operationType')), 1),
                              _createElementVNode("input", {
                                value: String(transaction.value.operationType)==='1' ? _ctx.$t('transactions.payin') : (String(transaction.value.operationType)==='2' ? _ctx.$t('transactions.payout') : transaction.value.operationType),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_240)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.clientId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                              _createElementVNode("label", _hoisted_242, _toDisplayString(_ctx.$t('transactions.clientId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((transaction.value.clientId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.clientId]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_243, [
                        (hasValue(transaction.value.currency))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                              _createElementVNode("label", _hoisted_245, _toDisplayString(_ctx.$t('transactions.currency')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((transaction.value.currency) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.currency]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.countryCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                              _createElementVNode("label", _hoisted_247, _toDisplayString(_ctx.$t('transactions.countryCode')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((transaction.value.countryCode) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.countryCode]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.totalFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                              _createElementVNode("label", _hoisted_249, _toDisplayString(_ctx.$t('transactions.totalFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.totalFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_250)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_251, [
                        (hasValue(transaction.value.imoneyFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                              _createElementVNode("label", _hoisted_253, _toDisplayString(_ctx.$t('transactions.imoneyFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.imoneyFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_254)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.operatorFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                              _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.$t('transactions.operatorFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.operatorFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_257)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.user?.email))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                              _createElementVNode("label", _hoisted_259, _toDisplayString(_ctx.$t('transactions.initiatedByUser')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.user?.email,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_260)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_261, [
                        (hasValue(transaction.value.business?.name))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                              _createElementVNode("label", _hoisted_263, _toDisplayString(_ctx.$t('transactions.businessLabel')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.business?.name,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_264)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.clientReference))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                              _createElementVNode("label", _hoisted_266, _toDisplayString(_ctx.$t('transactions.clientReference')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((transaction.value.clientReference) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.clientReference]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_267, [
                        (hasValue(transaction.value.handlingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                              _createElementVNode("label", _hoisted_269, _toDisplayString(_ctx.$t('transactions.handlingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.handlingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_270)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.processingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                              _createElementVNode("label", _hoisted_272, _toDisplayString(_ctx.$t('transactions.processingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.processingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_273)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.apiVersion))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                              _createElementVNode("label", _hoisted_275, _toDisplayString(_ctx.$t('transactions.apiVersion')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((transaction.value.apiVersion) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.apiVersion]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.finalStateDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                              _createElementVNode("label", _hoisted_277, _toDisplayString(_ctx.$t('transactions.finalStateDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.finalStateDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_278)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_279, [
                        (hasValue(transaction.value.checkingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                              _createElementVNode("label", _hoisted_281, _toDisplayString(_ctx.$t('transactions.checkingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.checkingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_282)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.errorMessage))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                              _createElementVNode("label", _hoisted_284, _toDisplayString(_ctx.$t('transactions.errorMessage')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((transaction.value.errorMessage) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: "",
                                style: {"color":"red"}
                              }, null, 512), [
                                [_vModelText, transaction.value.errorMessage]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (hasValue(transaction.value.description))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                            _createElementVNode("div", _hoisted_286, [
                              _createElementVNode("label", _hoisted_287, _toDisplayString(_ctx.$t('transactions.descriptionLabel')), 1),
                              _createElementVNode("textarea", {
                                value: transaction.value.description,
                                rows: "2",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_288)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 512)), [
                      [_vShow, activeDetailTab.value === 'advanced']
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_289, [
      _createElementVNode("div", _hoisted_290, [
        _createElementVNode("div", _hoisted_291, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(generateLink, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_292, [
              _createElementVNode("h1", _hoisted_293, _toDisplayString(_ctx.$t('transfers.paymentLink')), 1),
              _cache[122] || (_cache[122] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_294, [
              _createElementVNode("div", _hoisted_295, [
                _createElementVNode("h6", _hoisted_296, _toDisplayString(_ctx.$t('transfers.balance')), 1),
                _createElementVNode("h6", _hoisted_297, _toDisplayString(payoutBalance.value?.toLocaleString()) + " XOF", 1)
              ]),
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                    _createElementVNode("h6", _hoisted_299, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_300, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_301, [
                _createElementVNode("div", _hoisted_302, [
                  _createElementVNode("div", _hoisted_303, [
                    _createElementVNode("label", _hoisted_304, _toDisplayString(_ctx.$t('transfers.validationType')), 1),
                    _createElementVNode("select", {
                      name: "validationType",
                      id: "validationType",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleValidationTypeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_305, _toDisplayString(_ctx.$t('transfers.simple')), 1),
                      _createElementVNode("option", _hoisted_306, _toDisplayString(_ctx.$t('transfers.double')), 1)
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_307, [
                    _createElementVNode("label", _hoisted_308, _toDisplayString(_ctx.$t('transfers.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "1",
                        step: "1",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        placeholder: "ex: 2000",
                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((amount).value = $event)),
                        id: "amount",
                        onKeydown: blockInvalidAmountKeys,
                        onInput: _cache[65] || (_cache[65] = ($event: any) => (sanitizeAmount($event.target.value,$event.target)))
                      }, null, 544), [
                        [_vModelText, amount.value]
                      ])
                    ])
                  ]),
                  (_unref(result)==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_309, [
                        _createElementVNode("label", _hoisted_310, _toDisplayString(_ctx.$t('transfers.link')), 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_isRef(link) ? (link).value = $event : link = $event)),
                            id: "link",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, _unref(link)]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(result)==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_311, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-decoration-none",
                          onClick: copyToCliboard
                        }, [
                          _createElementVNode("label", _hoisted_312, _toDisplayString(_ctx.$t('transfers.link')), 1),
                          _cache[123] || (_cache[123] = _createElementVNode("i", {
                            class: "flaticon-draft fs-6",
                            style: {"color":"#000"}
                          }, null, -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_313, [
              _createElementVNode("button", {
                class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[67] || (_cache[67] = ($event: any) => (reset()))
              }, [
                _cache[124] || (_cache[124] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.refresh')), 1)
              ]),
              (_unref(current_permissions)('create_public_token'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn text-white",
                    style: {"background-color":"#EB9355"},
                    disabled: !btnLoad.value
                  }, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_315))
                      : _createCommentVNode("", true),
                    _cache[125] || (_cache[125] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('transfers.generatePaymentLink')), 1)
                  ], 8, _hoisted_314))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_316, [
      _createElementVNode("div", _hoisted_317, [
        _createElementVNode("div", _hoisted_318, [
          _cache[135] || (_cache[135] = _createStaticVNode("<button type=\"button\" class=\"btn-close status-modal-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-22f1a93e></button><div class=\"edit-status-header\" data-v-22f1a93e><div class=\"edit-status-icon\" data-v-22f1a93e><i class=\"flaticon-pen\" data-v-22f1a93e></i></div><h5 class=\"mb-0 mt-10\" data-v-22f1a93e>Modifier le statut</h5></div>", 2)),
          _createElementVNode("div", _hoisted_319, [
            _createElementVNode("div", _hoisted_320, [
              _cache[126] || (_cache[126] = _createElementVNode("span", { class: "edit-status-code-label" }, "Code transaction", -1)),
              _createElementVNode("span", _hoisted_321, _toDisplayString(changeStatusCheckoutId.value || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_322, [
              _cache[128] || (_cache[128] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Statut ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((newStatusValue).value = $event)),
                class: "form-select fs-md-15 text-black shadow-none edit-status-select"
              }, [...(_cache[127] || (_cache[127] = [
                _createElementVNode("option", { value: "OPEN" }, "OPEN", -1),
                _createElementVNode("option", { value: "COMPLETED" }, "COMPLETED", -1)
              ]))], 512), [
                [_vModelSelect, newStatusValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_323, [
              _cache[130] || (_cache[130] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Statut de paiement ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((newPaymentStatusValue).value = $event)),
                class: "form-select fs-md-15 text-black shadow-none edit-status-select"
              }, [...(_cache[129] || (_cache[129] = [
                _createStaticVNode("<option value=\"SUCCEEDED\" data-v-22f1a93e>SUCCEEDED</option><option value=\"FAILED\" data-v-22f1a93e>FAILED</option><option value=\"PENDING\" data-v-22f1a93e>PENDING</option><option value=\"PROCESSING\" data-v-22f1a93e>PROCESSING</option><option value=\"INITIATED\" data-v-22f1a93e>INITIATED</option><option value=\"SCHEDULED\" data-v-22f1a93e>SCHEDULED</option>", 6)
              ]))], 512), [
                [_vModelSelect, newPaymentStatusValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_324, [
              _cache[131] || (_cache[131] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Description "),
                _createElementVNode("span", { class: "text-muted fw-normal" }, "(facultatif)")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((newDescriptionValue).value = $event)),
                class: "form-control fs-md-15 text-black shadow-none edit-status-select",
                rows: "3",
                placeholder: "Ajouter une description…"
              }, null, 512), [
                [_vModelText, newDescriptionValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_325, [
              _cache[132] || (_cache[132] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" State "),
                _createElementVNode("span", { class: "text-muted fw-normal" }, "(facultatif)")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((newStateValue).value = $event)),
                type: "number",
                min: "0",
                max: "5",
                step: "1",
                class: "form-control fs-md-15 text-black shadow-none edit-status-select",
                placeholder: "0 à 5",
                onInput: onStateInput
              }, null, 544), [
                [_vModelText, newStateValue.value]
              ]),
              (stateError.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_326, _toDisplayString(stateError.value), 1))
                : _createCommentVNode("", true)
            ]),
            (changeStatusError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_327, _toDisplayString(changeStatusError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_328, [
            _cache[134] || (_cache[134] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "button",
              disabled: !btnLoadStatus.value,
              class: "btn edit-status-submit-btn",
              onClick: _cache[72] || (_cache[72] = ($event: any) => (submitChangeStatus()))
            }, [
              (!btnLoadStatus.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_330))
                : _createCommentVNode("", true),
              _cache[133] || (_cache[133] = _createElementVNode("span", { style: {"color":"#FFF"} }, "Valider", -1))
            ], 8, _hoisted_329)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_331, [
      _createElementVNode("div", _hoisted_332, [
        _createElementVNode("div", _hoisted_333, [
          _cache[139] || (_cache[139] = _createElementVNode("button", {
            type: "button",
            class: "btn-close status-modal-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1)),
          _createElementVNode("div", _hoisted_334, [
            (statusLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_335, [...(_cache[136] || (_cache[136] = [
                  _createElementVNode("span", {
                    class: "spinner-grow text-warning",
                    role: "status"
                  }, null, -1),
                  _createElementVNode("p", { class: "mt-15 mb-0 text-muted" }, "Vérification en cours...", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_336, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-icon-wrap", statusIconClass.value])
                  }, [
                    (statusDetails.value.paymentStatus==='SUCCEEDED' || statusDetails.value.paymentStatus==='SUCCESS')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_337))
                      : (statusDetails.value.paymentStatus==='FAILED')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_338))
                        : (_openBlock(), _createElementBlock("span", _hoisted_339, "⏳"))
                  ], 2),
                  _createElementVNode("h5", _hoisted_340, _toDisplayString(statusLabelText.value), 1),
                  _createElementVNode("p", _hoisted_341, _toDisplayString(statusDetails.value.payoutId || statusDetails.value.checkoutId), 1),
                  _createElementVNode("div", _hoisted_342, [
                    _createTextVNode(_toDisplayString(Number(statusDetails.value.amount || 0).toLocaleString()) + " ", 1),
                    _cache[137] || (_cache[137] = _createElementVNode("span", null, "F CFA", -1))
                  ]),
                  _createElementVNode("table", _hoisted_343, [
                    _cache[138] || (_cache[138] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Statut"),
                        _createElementVNode("th", null, "Statut paiement")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-pill", techStatusClass.value])
                          }, _toDisplayString(statusDetails.value.status || '—'), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-pill", paymentStatusClass.value])
                          }, _toDisplayString(statusDetails.value.paymentStatus || '—'), 3)
                        ])
                      ])
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "PDFReceipt",
      ref: PDFReceipt,
      id: "receipt",
      class: "form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none"
    }, [
      _createElementVNode("div", _hoisted_344, [
        _createElementVNode("h2", _hoisted_345, [
          _cache[140] || (_cache[140] = _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo-icon",
              style: {"max-width":"10%"}
            }),
            _createElementVNode("span", { class: "logo_text" }, "IZYPAY")
          ], -1)),
          _createElementVNode("span", _hoisted_346, _toDisplayString(_ctx.$t('transfers.transactionReceipt')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_347, [
        _cache[148] || (_cache[148] = _createStaticVNode("<div id=\"arrow-top-section\" data-v-22f1a93e><span id=\"arrow-top-left\" class=\"section_content\" data-v-22f1a93e><img src=\"" + _imports_1 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-22f1a93e></span><span id=\"arrow-top-right\" class=\"section_content\" data-v-22f1a93e><img src=\"" + _imports_2 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-22f1a93e></span></div>", 1)),
        _createElementVNode("div", _hoisted_348, [
          (transaction.value.clientId != '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_349, [
                _createElementVNode("span", _hoisted_350, _toDisplayString(_ctx.$t('transfers.beneficiary')), 1),
                _cache[141] || (_cache[141] = _createTextVNode(" : ", -1)),
                _createElementVNode("span", _hoisted_351, _toDisplayString(transaction.value.clientId), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_352, _toDisplayString(_ctx.$t('transfers.operator')), 1),
            _cache[142] || (_cache[142] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_353, _toDisplayString(operator.value), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_354, _toDisplayString(_ctx.$t('transfers.phone')), 1),
            _cache[143] || (_cache[143] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_355, _toDisplayString(transaction.value.contact), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_356, _toDisplayString(_ctx.$t('transfers.date')), 1),
            _cache[144] || (_cache[144] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_357, _toDisplayString(formatDateFr(new Date(transaction.value.transactionDate))), 1)
          ]),
          _createElementVNode("p", _hoisted_358, [
            _createElementVNode("span", _hoisted_359, _toDisplayString(_ctx.$t('transfers.transactionCode')), 1),
            _createElementVNode("span", _hoisted_360, _toDisplayString(transaction.value.payoutId), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_361, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_362, _toDisplayString(_ctx.$t('transfers.amountLabel')), 1),
            _createElementVNode("span", _hoisted_363, _toDisplayString(transaction.value.amount) + " F", 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_364, _toDisplayString(_ctx.$t('transfers.statusLabel')), 1),
            _createElementVNode("span", _hoisted_365, [
              _createTextVNode(_toDisplayString(transaction.value.paymentStatus) + " ", 1),
              _cache[145] || (_cache[145] = _createElementVNode("img", {
                src: _imports_3,
                alt: "logo-icon",
                style: {"max-width":"25%"}
              }, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_366, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_367, _toDisplayString(_ctx.$t('transfers.thankYou')), 1),
            _cache[146] || (_cache[146] = _createTextVNode("  ", -1)),
            _cache[147] || (_cache[147] = _createElementVNode("span", { class: "section_content" }, [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "logo-icon",
                style: {"max-width":"25%"}
              })
            ], -1))
          ])
        ]),
        _cache[149] || (_cache[149] = _createStaticVNode("<div id=\"arrow-bottom-section\" data-v-22f1a93e><span id=\"arrow-bottom-left\" class=\"section_content\" data-v-22f1a93e><img src=\"" + _imports_5 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-22f1a93e></span><span id=\"arrow-bottom-right\" class=\"section_content\" data-v-22f1a93e><img src=\"" + _imports_6 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-22f1a93e></span></div>", 1))
      ])
    ], 512),
    _cache[150] || (_cache[150] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})